import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import axiosPE from '../../api/axios'

const initialState = {
  portal: {},
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
}

export const fetchPortal = createAsyncThunk('/portal', async () => {
  const response = await axiosPE.get('/portal')
  return response.data
})

export const portalSlice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    setPortal: (state, action) => {
      // Reducer vacío - mantener para compatibilidad
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPortal.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchPortal.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.portal = action.payload.portal

        if (action.payload.portal.favicon) {
          document.querySelector('link[rel="icon"]').href =
            `assets/images/${action.payload.portal.favicon}`
        }
        if (action.payload.portal.parametros_seo.titulo || action.payload.portal.descripcion) {
          const title = document.querySelector('title')
          title.innerText =
            action.payload.portal.parametros_seo.titulo || action.payload.portal.descripcion
        }
        if (action.payload.portal.parametros_seo.descripcion) {
          const description = document.querySelector('meta[name="description"]')
          description.content = action.payload.portal.parametros_seo.descripcion
        }
        if (action.payload.portal.parametros_seo.palabras_clave) {
          let keywords = document.querySelector('meta[name="keywords"]')
          if (!keywords) {
            keywords = document.createElement('meta')
            keywords.name = 'keywords'
            document.head.appendChild(keywords)
          }
          keywords.content = action.payload.portal.parametros_seo.palabras_clave
        }
      })
      .addCase(fetchPortal.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  },
})

export const { setPortal } = portalSlice.actions
export const selectPortal = (state) => state.portal

export default portalSlice.reducer
